import { Controller, useForm } from 'react-hook-form';
import { IconButton, InputAdornment, Stack } from '@mui/material';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import ClearIcon from '@mui/icons-material/Clear';
import MDInput from 'components/MDInput';

export function LogAdvisorNodeForm({ id, data, onUpdateData }) {
  const { formatMessage: msg } = useIntl();

  const { control, setValue, watch } = useForm({
    defaultValues: {
      description: data?.description || '',
      logPath: data?.logPath || ''
    }
  });

  // Call onNodeChange only when form values actually change
  useEffect(() => {
    const subscription = watch((values) => {
      const updatedData = {
        ...data,
        ...values
      };
      onUpdateData({
        id,
        data: updatedData
      });
    });

    return () => subscription.unsubscribe();
  }, [watch, data, onUpdateData, id]);

  const clearField = (fieldName) => {
    setValue(fieldName, '');
  };

  return (
    <Stack spacing={1} sx={{ p: 1 }}>
      <Controller
        name="description"
        control={control}
        render={({ field }) => (
          <MDInput
            {...field}
            label={msg({ id: 'field.description.label' })}
            variant="filled"
            fullWidth
            size="small"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={msg({ id: 'tooltip.clear' })}>
                    <IconButton onClick={() => clearField('description')}>
                      <ClearIcon />
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              )
            }}
          />
        )}
      />
      <Controller
        name="logPath"
        control={control}
        render={({ field }) => (
          <MDInput
            {...field}
            label={msg({ id: 'field.advisors.log.path' })}
            variant="filled"
            fullWidth
            size="small"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={msg({ id: 'tooltip.clear' })}>
                    <IconButton onClick={() => clearField('logPath')}>
                      <ClearIcon />
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              )
            }}
          />
        )}
      />
    </Stack>
  );
}

LogAdvisorNodeForm.propTypes = {
  id: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string,
    description: PropTypes.string,
    logPath: PropTypes.string
  }),
  onUpdateData: PropTypes.func.isRequired
};
